
// import { Offcanvas } from 'bootstrap';

import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import CancelIcon from "@mui/icons-material/Cancel";
import { useFormik } from "formik";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
// import Accordion from 'react-bootstrap/Accordion';
import Cookies from "js-cookie";
import axios from 'axios';
// import { Offcanvas } from 'bootstrap';
import { FocusError } from 'focus-formik-error';
// import {
//     validationCreateServiceSchema,
// } from "../../../ValidationScema";
// import { admin, adminMainUrl } from "../../../Config";
// import Api from "../../../Api";
import { useLocation, useNavigate } from "react-router-dom";
// import Api from "../../Api";
// import { adminMainUrl } from "../../Config";
import Offcanvas from 'react-bootstrap/Offcanvas';
// import { validationCreateServiceSchema } from "../../ValidationScema";
import Accordion from 'react-bootstrap/Accordion';
import Api from "../../../Api";
import { adminMainUrl } from "../../../Config";
import { validationCreateServiceSchema } from "../../../ValidationScema";


const EditQuoteForm = ({ id, QuotationId, ViewDetails, handleClose,show}) => {

    // useEffect(() => {
    //     const offcanvasElement = document.getElementById(id);
    //     const offcanvasInstance = new Offcanvas(offcanvasElement, {
    //         backdrop: false, // prevents closing on outside click
    //         keyboard: false, // disables closing with ESC key
    //     });

    //     return () => {
    //         offcanvasInstance.dispose(); // Clean up when the component unmounts
    //     };
    // }, [id]);

    const modalButtonRef = useRef(null);
    // const closeButtonRef = useRef(null);
    // console.log(ViewDetails, "ViewDetails....//")
    const location = useLocation();
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState(new Date());
    const [productType, setProductTypes] = useState([]);
    const [cargoType, setCargoType] = useState([]);
    const [shipmentMode, setShipmentMode] = useState([]);
    const [shipmentType, setShipmentType] = useState([]);
    const [shipmentVia, setShipmentVia] = useState([]);
    const [packageType, setPackageType] = useState([]);
    const [selectedImg, setSelectedImg] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState([]);
    const [weightUnit, setWeightUnit] = useState([]);
    const [RequiredServiceId, setRequiredServiceId] = useState([]);
    const [viewDetails, setViewDetails] = useState(null);
    const [quotationId, setQuotationId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    // console.log(viewDetails, "viewDetails....")
    // useEffect(() => {
    //     const offcanvasElement = document.getElementById(id);
    //     const offcanvasInstance = new Offcanvas(offcanvasElement, {
    //         backdrop: 'static', // prevents closing on outside click
    //         keyboard: false, // disables closing with ESC key
    //     });

    //     return () => {
    //         offcanvasInstance.dispose(); // Clean up when the component unmounts
    //     };
    // }, [id]);
    useEffect(() => {
        if (QuotationId) {
            setQuotationId(QuotationId)
        }
    }, [QuotationId])
    useEffect(() => {

        if (QuotationId) {
            ViewQuotation()
        }
    }, [QuotationId]);
    const isLastRowFilled = () => {
        const lastRow =
            formik.values.package_info[formik.values.package_info?.length - 1];
        return Object.values(lastRow).every((value) => value !== "");
    };
    const handleRemoveRow = (index) => {
        const updatedPackageInfo = formik.values.package_info.filter(
            (_, i) => i !== index
        );
        formik.setFieldValue("package_info", updatedPackageInfo);
    };

    const handleAddRow = () => {
        if (isLastRowFilled()) {
            formik.setFieldValue("package_info", [
                ...formik.values.package_info,
                {
                    package_type_id: "",
                    length: "",
                    width: "",
                    height: "",
                    max_weight: "",
                    max_weight_unit_id: "",
                    gross_weight: "",
                    gross_weight_unit_id: "",
                    total_boxes: ""
                },
            ]);
        } else {
            Swal.fire(
                "Error",
                "Please fill in all fields before adding a new row.",
                "error"
            );
        }
    };

    const GetProductType = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/product-type/get`, "GET");

            // Filter to include only items where status is true
            const options = data?.data
                ?.filter((item) => item.status === true)
                .map((item) => ({
                    productId: item.id,
                    value: item.name,
                    label: item.name,
                }));

            setProductTypes(options);
        } catch (error) {
            setProductTypes([]);
            console.error("Error fetching data:", error);
        }
    };

    const GetWeightUnit = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/weight-unit/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    WeightUnitId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setWeightUnit(options);
        } catch (error) {
            setWeightUnit([]);

            console.error("Error fetching data:", error);
        }
    };
    const RequiredService = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/required-service/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    RequiredServiceId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setRequiredServiceId(options);
        } catch (error) {
            setRequiredServiceId([]);

            console.error("Error fetching data:", error);
        }
    };
    const GetCargoType = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/cargo-type/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    cargoId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setCargoType(options);
        } catch (error) {
            setCargoType([]);

            console.error("Error fetching data:", error);
        }
    };
    const GetShipmentMode = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/shipment-mode/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    shipmentModeId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setShipmentMode(options);
        } catch (error) {
            setShipmentMode([]);

            console.error("Error fetching data:", error);
        }
    };
    const GetShipmentType = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/shipment-type/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    shipmentTypeId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setShipmentType(options);
        } catch (error) {
            setShipmentType([]);

            console.error("Error fetching data:", error);
        }
    };
    const GetShipmentVia = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/shipment-via/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    shipmentViaId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setShipmentVia(options);
        } catch (error) {
            setShipmentVia([]);

            console.error("Error fetching data:", error);
        }
    };
    const GetPackageType = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/package-type/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    packageTypeId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setPackageType(options);
        } catch (error) {
            setPackageType([]);

            console.error("Error fetching data:", error);
        }
    };
    const unit = [{ value: "kg", label: "1" }];


    const cancelImage = (index) => {
        const newImages = formik.values.files.filter(
            (_, i) => i !== index
        );
        formik.setFieldValue("files", newImages);
        setSelectedImg(newImages);
    };

    const cancelVideo = (index) => {
        const newVideos = formik.values.videos.filter(
            (_, i) => i !== index
        );
        formik.setFieldValue("videos", newVideos);
        setSelectedVideo(newVideos);
    };
    const token = Cookies.get("token");
    const formik = useFormik({
        initialValues: {
            quotation_id: "",
            full_name: "",
            phone: "",
            email: "",
            origin: "",
            destination: "",
            product_name: "",
            product_type_id: "",
            shipment_type_id: "",
            shipment_mode_id: "",
            shipment_via_id: "",
            cargo_type_id: "",
            required_servie_id: "",
            expected_transit_date: "",
            detailed_requirement: "",
            agreement: 0,
            package_info: [{
                package_type_id: "",
                length: "",
                width: "",
                height: "",
                max_weight: "",
                max_weight_unit_id: "",
                gross_weight: "",
                gross_weight_unit_id: "",
                total_boxes: ""
            }],
            files: [],
            videos: ""
        },
        validationSchema: validationCreateServiceSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setIsSubmitting(true);
            let parsedValues = { ...values };

            try {
                // Parse package_info if it's in JSON string format
                parsedValues.package_info = JSON.parse(values.package_info);
            } catch (error) {
                // console.error("Error parsing package_info:", error);
            }

            // Ensure specific IDs are submitted as strings
            parsedValues.product_type_id = String(viewDetails?.product_type?.id || "");
            parsedValues.shipment_type_id = String(viewDetails?.shipment_type?.id || "");
            parsedValues.shipment_mode_id = String(viewDetails?.shipment_mode?.id || "");
            parsedValues.shipment_via_id = String(viewDetails?.shipment_via?.id || "");
            parsedValues.cargo_type_id = String(viewDetails?.cargo_type?.id || "");
            parsedValues.required_servie_id = String(viewDetails?.required_servie_id || "");

            try {
                // Apply trimming and ensure all package_info fields are strings
                if (Array.isArray(parsedValues.package_info)) {
                    parsedValues.package_info = parsedValues.package_info.map((pkg) => ({
                        ...pkg,
                        package_type_id: String(pkg.package_type_id || "").trim(),
                        length: String(pkg.length || "").trim(),
                        width: String(pkg.width || "").trim(),
                        height: String(pkg.height || "").trim(),
                        max_weight: String(pkg.max_weight || "").trim(),
                        max_weight_unit_id: String(pkg.max_weight_unit_id || "").trim(),
                        gross_weight: String(pkg.gross_weight || "").trim(),
                        gross_weight_unit_id: String(pkg.gross_weight_unit_id || "").trim(),
                        total_boxes: String(pkg.total_boxes || "").trim(),
                    }));
                }

                // Stringify package_info before submission
                parsedValues.package_info = JSON.stringify(parsedValues.package_info);

                // Send the POST request with the parsed and stringified data
                const response = await axios.post(`${adminMainUrl}/api/quotation/update`, parsedValues, {
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': token,
                    },
                });
                modalButtonRef.current.click();
                // resetForm();
                toast.success(response.data.msg);
                // navigate(-1);
            } catch (error) {
                console.error("API Error:", error);
            } finally {
                setSubmitting(false);
            }
        }
    });
    useEffect(() => {
        GetProductType();
        GetCargoType();
        GetShipmentMode();
        GetShipmentType();
        GetShipmentVia();
        GetPackageType();
        RequiredService();
        GetWeightUnit()
    }, []);
    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    const ViewQuotation = async (information) => {
        // setSpinnerLoader(true)
        try {
            const token = Cookies.get("token");
            const requesId = {
                quotation_id: `${quotationId}`,
            };
            const response = await fetch(`${adminMainUrl}/api/quotation/view`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                },
                body: JSON.stringify(requesId),
            });
            if (!response.ok) {
                // setSpinnerLoader(false);
                toast.error(data?.msg);
                // setIsVisible(false);
                // navigate(-1)
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            // toast.success(data?.msg);
            // console.log(data, "data............")
            setViewDetails(data?.data)
            // setViewData(data?.data);
            // setIsVisible(false)
            // setSpinnerLoader(false);
        } catch (error) {
            // setIsVisible(false)
            // setSpinnerLoader(false);
            console.log(error);
        }
    };

    useEffect(() => {
        if (quotationId) {
            formik.setValues({
                agreement: 0,
                quotation_id: `${quotationId}` || "",
                full_name: `${viewDetails?.full_name}` || "",
                phone: `${viewDetails?.phone}` || "",
                email: `${viewDetails?.email}` || "",
                origin: `${viewDetails?.origin}` || "",
                destination: `${viewDetails?.destination}` || "",
                product_name: `${viewDetails?.product_name}` || "",
                product_type_id: viewDetails?.product_type?.id || "",
                shipment_type_id: viewDetails?.shipment_type?.id || "",
                shipment_mode_id: viewDetails?.shipment_mode?.id || "",
                shipment_via_id: viewDetails?.shipment_via?.id || "",
                cargo_type_id: viewDetails?.cargo_type.id || "",
                required_servie_id: viewDetails?.required_servie_id || "",
                expected_transit_date: `${viewDetails?.expected_transit_date}` || "",
                detailed_requirement: `${viewDetails?.detailed_requirement}` || "",
                package_info: viewDetails?.package_info || [],
                files: `${viewDetails?.files}` || [],
                videos: `${viewDetails?.videos}` || ""
            });
        }
    }, [quotationId]);
    // console.log(formik.values, "formik.values.package_info")
    return (
        <div>
            <Offcanvas show={show} onHide={handleClose} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit Quote Form</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit}>
                        <FocusError formik={formik} />

                        <div className="accordion" id="main_accordion">
                            {/* Basic Info */}
                            <div className="accordion-item rounded mb-3">
                                <div className="accordion-header">
                                    <a
                                        href="#"
                                        className="accordion-button accordion-custom-button bg-white rounded fw-medium text-dark"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#basic"
                                    >
                                        <span className="avatar avatar-md rounded text-dark border me-2">
                                            <i className="ti ti-user-plus fs-20" />
                                        </span>
                                        General information
                                    </a>
                                </div>
                                <div
                                    className="accordion-collapse collapse show"
                                    id="basic"
                                    data-bs-parent="#main_accordion"
                                >
                                    <div className="accordion-body border-top mt-0">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="input_box_section ">
                                                    <label>
                                                        Full Name <span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="full_name"
                                                        className="form-control"
                                                        placeholder="Enter Name here"
                                                        value={formik?.values?.full_name}
                                                        // value={viewDetails?.full_name}
                                                        onChange={formik?.handleChange}
                                                        onBlur={formik?.handleBlur}
                                                        pattern="[a-zA-Z\s]*"
                                                        onKeyPress={(event) => {
                                                            if (!/[a-zA-Z\s]/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                    {formik?.touched.full_name && formik?.errors.full_name ? (
                                                        <div className="error">{formik?.errors.full_name}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="input_box_section ">
                                                    <label>
                                                        Phone Number <span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Phone Number"
                                                        name="phone"
                                                        // value={viewDetails?.phone}
                                                        value={formik?.values?.phone}
                                                        onChange={formik?.handleChange}
                                                        onBlur={formik?.handleBlur}
                                                        pattern="\d*"
                                                        onKeyPress={(event) => {
                                                            if (!/\d/.test(event.key)) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                    {formik?.touched?.phone && formik?.errors?.phone ? (
                                                        <div className="error">{formik?.errors?.phone}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="input_box_section ">
                                                    <label>
                                                        Email Id <span>*</span>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Enter Email"
                                                        name="email"
                                                        // value={viewDetails?.email}
                                                        value={formik?.values.email}
                                                        onChange={formik?.handleChange}
                                                        onBlur={formik?.handleBlur}
                                                    />
                                                    {formik?.touched.email && formik?.errors?.email ? (
                                                        <div className="error">{formik?.errors?.email}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="input_box_section ">
                                                    <label>
                                                        Origin <span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Origin "
                                                        name="origin"
                                                        // value={viewDetails?.origin}
                                                        value={formik?.values?.origin}
                                                        onChange={formik?.handleChange}
                                                        onBlur={formik?.handleBlur}
                                                    />
                                                    {formik?.touched?.origin && formik?.errors?.origin ? (
                                                        <div className="error">{formik?.errors?.origin}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="input_box_section ">
                                                    <label>
                                                        Destination <span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Destination"
                                                        name="destination"
                                                        // value={viewDetails?.destination}
                                                        value={formik?.values?.destination}
                                                        onChange={formik?.handleChange}
                                                        onBlur={formik?.handleBlur}
                                                    />
                                                    {formik.touched.destination &&
                                                        formik.errors.destination ? (
                                                        <div className="error">{formik.errors.destination}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Basic Info */}
                            {/* Address Info */}
                            <div className="accordion-item border-top rounded mb-3 py-0">
                                <div className="accordion-header">
                                    <a
                                        href="#"
                                        className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#address"
                                    >
                                        <span className="avatar avatar-md rounded text-dark border me-2">
                                            <i className="ti ti-map-pin-cog fs-20" />
                                        </span>
                                        Pickup Information
                                    </a>
                                </div>
                                <div
                                    className="accordion-collapse collapse"
                                    id="address"
                                    data-bs-parent="#main_accordion"
                                >
                                    <div className="accordion-body border-top mt-0">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="input_box_section">
                                                    <label>
                                                        Product Name <span>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="product_name"
                                                        className="form-control"
                                                        placeholder="Enter Product Name"
                                                        // value={viewDetails?.product_name}
                                                        value={formik?.values?.product_name}
                                                        onChange={formik?.handleChange}
                                                        onBlur={formik?.handleBlur}
                                                    />
                                                    {formik.touched.product_name &&
                                                        formik.errors.product_name ? (
                                                        <div className="error">
                                                            {formik.errors.product_name}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="input_box_section">
                                                    <label>Product Type</label>
                                                    <div className="mt-2">
                                                        <Select
                                                            options={productType}
                                                            value={productType.find(option => option.productId === formik.values.product_type_id)}
                                                            onChange={(selectedOption) =>
                                                                formik.setFieldValue(`product_type_id`, selectedOption.productId)
                                                            }
                                                            onBlur={formik.handleBlur}
                                                        />

                                                    </div>
                                                    {formik.touched.product_type_id &&
                                                        formik.errors.product_type_id ? (
                                                        <div className="error">
                                                            {formik.errors.product_type_id}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="input_box_section">
                                                    <label>
                                                        Shipment Type <span>*</span>
                                                    </label>
                                                    <div className="mt-2">
                                                        <Select
                                                            options={shipmentType}
                                                            value={shipmentType.find(option => option.shipmentTypeId === formik.values.shipment_type_id)}
                                                            onChange={(selectedOption) =>
                                                                formik.setFieldValue(
                                                                    "shipment_type_id",
                                                                    selectedOption.shipmentTypeId
                                                                )
                                                            }
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </div>
                                                    {formik.touched.shipment_type_id &&
                                                        formik.errors.shipment_type_id ? (
                                                        <div className="error">
                                                            {formik.errors.shipment_type_id}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="input_box_section">
                                                    <label>
                                                        Shipment Mode <span>*</span>
                                                    </label>
                                                    <div className="mt-2">
                                                        <Select
                                                            options={shipmentMode}
                                                            value={shipmentMode.find(option => option.shipmentModeId === formik.values.shipment_mode_id)}
                                                            onChange={(selectedOption) =>
                                                                formik.setFieldValue(
                                                                    "shipment_mode_id",
                                                                    selectedOption.shipmentModeId
                                                                )
                                                            }
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </div>
                                                    {formik.touched.shipment_mode_id &&
                                                        formik.errors.shipment_mode_id ? (
                                                        <div className="error">
                                                            {formik.errors.shipment_mode_id}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="input_box_section">
                                                    <label>
                                                        Shipment Via <span>*</span>
                                                    </label>
                                                    <div className="mt-2">
                                                        <Select
                                                            options={shipmentVia}
                                                            value={shipmentVia.find(option => option.shipmentViaId === formik.values.shipment_via_id)}
                                                            onChange={(selectedOption) =>
                                                                formik.setFieldValue(
                                                                    "shipment_via_id",
                                                                    selectedOption.shipmentViaId
                                                                )
                                                            }
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </div>
                                                    {formik.touched.shipment_via_id &&
                                                        formik.errors.shipment_via_id ? (
                                                        <div className="error">
                                                            {formik.errors.shipment_via_id}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="input_box_section">
                                                    <label>
                                                        Cargo Type <span>*</span>
                                                    </label>
                                                    <div className="mt-2">
                                                        <Select
                                                            options={cargoType}

                                                            value={cargoType.find(option => option.cargoId === formik.values.cargo_type_id)}
                                                            onChange={(selectedOption) =>
                                                                formik.setFieldValue(
                                                                    "cargo_type_id",
                                                                    selectedOption.cargoId
                                                                )
                                                            }
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </div>
                                                    {formik.touched.cargo_type_id &&
                                                        formik.errors.cargo_type_id ? (
                                                        <div className="error">
                                                            {formik.errors.cargo_type_id}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input_box_section">
                                                    <label>
                                                        Required Service <span>*</span>
                                                    </label>
                                                    <div className="mt-2">
                                                        <Select
                                                            options={RequiredServiceId}
                                                            value={RequiredServiceId.find(option => option.RequiredServiceId === formik.values.required_servie_id)}
                                                            onChange={(selectedOption) =>
                                                                formik.setFieldValue(
                                                                    "required_servie_id",
                                                                    selectedOption.RequiredServiceId
                                                                )
                                                            }
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.required_servie_id &&
                                                            formik.errors.required_servie_id ? (
                                                            <div className="error">
                                                                {formik.errors.required_servie_id}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                {/* <div className="input_box_section">
                                                <label>
                                                    Expected Transit Date <span>*</span>
                                                </label>
                                                <div
                                                    className="custom-datepicker"
                                                    style={{ position: "relative" }}
                                                >
                                                    <DatePicker
                                                        selected={formik.values.expected_transit_date ? new Date(formik.values.expected_transit_date) : startDate} // Display the existing date if available
                                                        minDate={new Date()}
                                                        onChange={(date) => {
                                                            if (date < new Date().setHours(0, 0, 0, 0)) {
                                                                Swal.fire(
                                                                    "Error",
                                                                    "Expected Date can not in past date",
                                                                    "error"
                                                                );
                                                                setStartDate(null);
                                                                formik.setFieldValue("expected_transit_date", "");
                                                            } else {
                                                                setStartDate(date);
                                                                formik.setFieldValue(
                                                                    "expected_transit_date",
                                                                    date
                                                                );
                                                            }
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    <img
                                                        src="/img/Calendar.png"
                                                        alt=""
                                                        style={{
                                                            position: "absolute",
                                                            top: "20px",
                                                            right: "12px",
                                                        }}
                                                    />
                                                </div>
                                                {formik.touched.expected_transit_date &&
                                                    formik.errors.expected_transit_date ? (
                                                    <div className="error">
                                                        {formik.errors.expected_transit_date}
                                                    </div>
                                                ) : null}
                                            </div> */}
                                            </div>

                                            <div className="col-md-12">
                                                <div className="input_box_section">
                                                    <label>
                                                        Detailed Requirement <span>*</span>
                                                    </label>
                                                    <textarea
                                                        name="detailed_requirement"
                                                        className="form-control"
                                                        placeholder="Enter Detailed Requirement"
                                                        // value={viewDetails?.detailed_requirement}
                                                        value={formik?.values?.detailed_requirement}
                                                        onChange={formik?.handleChange}
                                                        onBlur={formik?.handleBlur}
                                                        rows={5}
                                                    />
                                                    {formik.touched.detailed_requirement &&
                                                        formik.errors.detailed_requirement ? (
                                                        <div className="error">
                                                            {formik.errors.detailed_requirement}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Address Info */}
                            {/* Social Profile */}
                            <div className="accordion-item border-top rounded mb-3 py-0">
                                <div className="accordion-header">
                                    <a
                                        href="#"
                                        className="accordion-button accordion-custom-button rounded bg-white fw-medium text-dark"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#social"
                                    >
                                        <span className="avatar avatar-md rounded text-dark border me-2">
                                            <i className="ti ti-social fs-20" />
                                        </span>
                                        Package Dimensions/Weight
                                    </a>
                                </div>
                                <div
                                    className="accordion-collapse collapse"
                                    id="social"
                                    data-bs-parent="#main_accordion"
                                >
                                    <div className="accordion-body border-top mt-0">
                                        <div>
                                            {
                                                formik.values.package_info?.map((packageItem, index) => (
                                                    <div key={index} className={`row ${index > 0 ? 'border-top' : ''}`}  >
                                                        <div className="col-md-12 d-md-flex justify-content-between align-items-start">
                                                            <div className="input_box_section form-group">
                                                                <div className="input-section">
                                                                    <label htmlFor="quantity">Quantity *</label>
                                                                    <div className="quantity-input">
                                                                        <input
                                                                            pattern="\d*"
                                                                            onKeyPress={(event) => {
                                                                                if (!/\d/.test(event.key)) {
                                                                                    event.preventDefault();
                                                                                }
                                                                            }}
                                                                            min={1}
                                                                            type="number"
                                                                            placeholder="Enter Quantity"
                                                                            value={packageItem.total_boxes}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            name={`package_info.${index}.total_boxes`}
                                                                            maxLength={8}
                                                                        />
                                                                    </div>
                                                                    {formik.touched.package_info?.[index]?.total_boxes &&
                                                                        formik.errors.package_info?.[index]?.total_boxes ? (
                                                                        <div className="error">
                                                                            {formik.errors.package_info[index].total_boxes}
                                                                        </div>
                                                                    ) : null}
                                                                </div>

                                                                <div className="input-section">
                                                                    <label>Packaging *</label>
                                                                    <div className="packaging-options mt-2">
                                                                        {packageType.map((option, pkgIndex) => (
                                                                            <button
                                                                                type="button"
                                                                                key={pkgIndex}
                                                                                className={`package-btn ${formik.values.package_info?.[index]?.package_type?.name === option?.package_type?.name ? 'active' : ''}`}
                                                                                onClick={() => {

                                                                                    formik.setFieldValue(`package_info.${index}.package_type_id`, option.value);
                                                                                }}
                                                                            >
                                                                                {option.label}
                                                                                {formik.values.package_info?.[index]?.package_type_id === option.value && (
                                                                                    <span className="check-icon">✔</span>
                                                                                )}
                                                                            </button>
                                                                        ))}

                                                                    </div>
                                                                    {formik.touched.package_info?.[index]?.package_type_id &&
                                                                        formik.errors.package_info?.[index]?.package_type_id ? (
                                                                        <div className="error">
                                                                            {formik.errors.package_info[index].package_type_id}
                                                                        </div>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                            <div className='d-flex justify-content-center align-items-center gap-3'>
                                                                <button
                                                                    type="button"
                                                                    className='bg-none add-package input_box_section p-0 d-flex justify-content-center align-items-center'
                                                                    onClick={handleAddRow}
                                                                    style={{ width: "39px", height: "39px" }}
                                                                >
                                                                    <span className=''>
                                                                        <img src="/img/pla.png" alt="img" />
                                                                    </span>
                                                                </button>

                                                                {formik.values.package_info.length > 1 && (
                                                                    <button
                                                                        className="remoove btn  w-fit input_box_section"
                                                                        onClick={() => handleRemoveRow(index)}
                                                                    >
                                                                        <i className="fa-solid fa-trash"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group-1 ">
                                                                <label for="dimensions">Dimensions (L x W x H per box) <span className="required">*</span></label>
                                                                <div className="dimensions-input-container mt-2">
                                                                    <div className="input-wrapper">
                                                                        <input type="number" id="length" placeholder="Length"
                                                                            value={packageItem.length}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            name={`package_info.${index}.length`}
                                                                            pattern="\d*"
                                                                            min={1}
                                                                            maxLength={4}
                                                                            onKeyPress={(event) => {
                                                                                if (!/\d/.test(event.key)) {
                                                                                    event.preventDefault();
                                                                                }
                                                                            }} className="dimension-input" />

                                                                    </div>
                                                                    <div className="input-wrapper">
                                                                        <input type="number" id="width" placeholder="Width"
                                                                            value={packageItem.width}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            name={`package_info.${index}.width`}
                                                                            pattern="\d*"
                                                                            min={1}
                                                                            maxLength={4}
                                                                            onKeyPress={(event) => {
                                                                                if (!/\d/.test(event.key)) {
                                                                                    event.preventDefault();
                                                                                }
                                                                            }} className="dimension-input" />

                                                                    </div>
                                                                    <div className="input-wrapper">
                                                                        <input type="number" id="height" placeholder="Height"
                                                                            value={packageItem.height}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            name={`package_info.${index}.height`}
                                                                            pattern="\d*"
                                                                            maxLength={4}
                                                                            min={1}
                                                                            onKeyPress={(event) => {
                                                                                if (!/\d/.test(event.key)) {
                                                                                    event.preventDefault();
                                                                                }
                                                                            }} className="dimension-input" />

                                                                    </div>
                                                                    <select className="unit-select">
                                                                        <option value="cm">Cm</option>
                                                                        <option value="inches">Inches</option>
                                                                    </select>
                                                                </div>
                                                                {formik.touched.package_info?.[index]?.length &&
                                                                    formik.errors.package_info?.[index]?.length ? (
                                                                    <div className="error">{formik.errors.package_info[index].length}</div>
                                                                ) : null}
                                                                {formik.touched.package_info?.[index]?.width &&
                                                                    formik.errors.package_info?.[index]?.width &&
                                                                    !formik.errors.package_info?.[index]?.length ? (
                                                                    <div className="error">{formik.errors.package_info[index].width}</div>
                                                                ) : null}
                                                                {formik.touched.package_info?.[index]?.height &&
                                                                    formik.errors.package_info?.[index]?.height &&
                                                                    !formik.errors.package_info?.[index]?.length &&
                                                                    !formik.errors.package_info?.[index]?.width ? (
                                                                    <div className="error">{formik.errors.package_info[index].height}</div>
                                                                ) : null}

                                                            </div>

                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="weight-unit-form">
                                                                <label htmlFor="weight">
                                                                    Max Weight (per box) <span className="required">*</span>
                                                                </label>
                                                                <div className="dimensions-input-container mt-2">
                                                                    <div className="input-wrapper">
                                                                        <input type="number"
                                                                            min={1}
                                                                            placeholder="Max weight"
                                                                            value={packageItem.max_weight}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            name={`package_info.${index}.max_weight`}
                                                                            pattern="\d*"
                                                                            maxLength={8}
                                                                            onKeyPress={(event) => {
                                                                                if (!/\d/.test(event.key)) {
                                                                                    event.preventDefault();
                                                                                }
                                                                            }} className="dimension-input-1" />

                                                                    </div>


                                                                    <select
                                                                        id={`unit-select-${index}`}
                                                                        className="unit-select"

                                                                        value={formik.values.package_info?.[index]?.max_weight_unit_id || ''}
                                                                        onChange={(event) =>
                                                                            formik.setFieldValue(`package_info.${index}.max_weight_unit_id`, event.target.value)
                                                                        }
                                                                        onBlur={formik.handleBlur}
                                                                        name={`package_info.${index}.max_weight_unit_id`}
                                                                    >
                                                                        <option value="" disabled>Select unit</option>
                                                                        {weightUnit.map((unit) => (
                                                                            <option key={unit.WeightUnitId} value={unit.WeightUnitId}>
                                                                                {unit.label}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                {(formik.touched.package_info?.[index]?.max_weight_unit_id && formik.errors.package_info?.[index]?.max_weight_unit_id) ||
                                                                    (formik.touched.package_info?.[index]?.max_weight && formik.errors.package_info?.[index]?.max_weight) ? (
                                                                    <div className="error">
                                                                        {formik.errors.package_info?.[index]?.max_weight_unit_id || formik.errors.package_info?.[index]?.max_weight}
                                                                    </div>
                                                                ) : null}

                                                            </div>
                                                        </div>

                                                        <div className="col-md-6">
                                                            <div className="weight-unit-form">
                                                                <label htmlFor="weight">
                                                                    Total Gross Weight <span className="required">*</span>
                                                                </label>
                                                                <div className="dimensions-input-container mt-2">
                                                                    <div className="input-wrapper">
                                                                        <input pattern="\d*"
                                                                            onKeyPress={(event) => {
                                                                                if (!/\d/.test(event.key)) {
                                                                                    event.preventDefault();
                                                                                }
                                                                            }}
                                                                            type="number"
                                                                            min={1}
                                                                            placeholder="Gross Weight"
                                                                            value={packageItem.gross_weight}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            name={`package_info.${index}.gross_weight`}
                                                                            maxLength={8} className="dimension-input-1" />

                                                                    </div>
                                                                    <select
                                                                        id={`unit-select-${index}`}
                                                                        className="unit-select"
                                                                        value={formik.values.package_info?.[index]?.gross_weight_unit_id || ''}
                                                                        onChange={(event) =>
                                                                            formik.setFieldValue(
                                                                                `package_info.${index}.gross_weight_unit_id`,
                                                                                event.target.value
                                                                            )
                                                                        }
                                                                        onBlur={formik.handleBlur}
                                                                        name={`package_info.${index}.gross_weight_unit_id`}
                                                                    >
                                                                        <option value="" disabled>Select unit</option>
                                                                        {weightUnit.map((unit) => (
                                                                            <option key={unit.WeightUnitId} value={unit.WeightUnitId}>
                                                                                {unit.label}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>

                                                                {(formik.touched.package_info?.[index]?.gross_weight_unit_id && formik.errors.package_info?.[index]?.gross_weight_unit_id) ||
                                                                    (formik.touched.package_info?.[index]?.gross_weight && formik.errors.package_info?.[index]?.gross_weight) ? (
                                                                    <div className="error">
                                                                        {formik.errors.package_info?.[index]?.gross_weight_unit_id || formik.errors.package_info?.[index]?.gross_weight}
                                                                    </div>
                                                                ) : null}

                                                            </div>
                                                        </div>


                                                    </div>

                                                ))
                                            }


                                            <div className="col-md-6">
                                                <div className="main-nav-det ">


                                                    <div className="main_package_formar mt-3">
                                                        <input

                                                            disabled
                                                            type="text"
                                                            className="form-control w-fit"
                                                            readOnly=""
                                                            placeholder="Download Package List Format"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="d-flex align-items-center justify-content-end">
                            <button
                                type="button"
                                data-bs-dismiss="offcanvas"
                                className="btn btn-light me-2"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit" disabled={isSubmitting}
                                className="btn btn-primary"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                            >
                                update
                            </button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas >
        </div>
    )
}

export default EditQuoteForm